import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M11.4 2.1c-.3-.1-.6-.1-.9 0-.3.2-.5.6-.5.9 0 0 0 2.6-1.7 4.3-.3.2-.5.5-.8.7C5.9 9.4 4 11.2 4 15c0 4.6 3.8 6.6 5.8 7 .4.1.9-.1 1.1-.5.2-.4.1-.9-.1-1.2 0 0-.7-.8-.7-2.3 0-.8.4-1.6.9-2.6.3-.5.5-1 .7-1.6 1 1.2 2.3 2.8 2.3 4.2 0 1.4-.2 1.9-.3 2.1-.4.1-.7.5-.7.9 0 .6.4 1 1 1h.1c.8-.1 5.9-.7 5.9-8 0-7.5-8.2-11.7-8.6-11.9zm4.5 17.2c0-.4.1-.8.1-1.3 0-3.4-3.9-6.5-4.4-6.8-.2-.1-.4-.2-.6-.2-.2 0-.3 0-.4.1-.4.2-.6.5-.6.9 0 .8-.4 1.6-.9 2.6S8 16.8 8 18c0 .4 0 .8.1 1.1C7 18.4 6 17.1 6 15c0-2.9 1.4-4.2 2.9-5.5l.8-.8c1.3-1.3 1.9-2.9 2.1-4.1C13.9 6 18 9.3 18 14c0 3.1-1 4.6-2.1 5.3z" />,
  'Fire'
)
